import React, { Fragment } from 'react'
import { useEffect } from 'react';
import { useAddNewAppIndividualAssetMutation, useDeleteAppIndividualAssetMutation, useGetAppIndividualAssetsQuery, useUpdateAppIndividualAssetMutation } from '../../../features/appindividualassets/appindassetsApiSlice';
import { Table, TableBody, TableCell, TableContainer,
   TableHead, TableRow, Paper, TablePagination} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import AppIndAsstReadOnly from './AppIndAsstReadOnly';
import AppIndAsstEditable from './AppIndAsstEditable';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ExcelDownload from '../../../data/exceldownload';
import { useGetUsersQuery } from '../../../features/users/usersApiSlice';
import { useGetAssetMastersQuery} from '../../../features/assetmasterApiSlice/assetmasterApiSlice';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Addcategform = styled.form`
  display: flex;
  margin:10px;
  align-items: center;
  justify-content:space-between;
`
const SubWrapper = styled.div`
  display: flex;
  margin:10px;
  align-items: center;  
  
`
const Button2Div =styled.div`
  display: flex;
  justify-content: end;
`

const ChipDiv = styled.div`
  background-color: #d4d5d6;
  display: inline-block;
  font-size: 14px;
  border-radius: 30px;
  height: 30px;
  padding: 0 4px 0 1rem;
  display: inline-flex;
  align-items: center;
  margin: 0 0.3rem 0.3rem 0;
`

const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
`
const ComplaintCategoryWrapper =styled.div`
  display: flex;
  justify-content:space-between;
  align-items:center;
`

const tableFontSize = 18;


function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};


const AppIndividualAssets = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tabledata, setTabledata]= useState([]);
  const [editCategory, setEditCategory]=useState(null);
  const [editFormData, setEditFormData]=useState({
    id:"",
    asset:"",
    category:"",
    dual:""
  });
  const [newValue, setNewValue] = useState({
    category:"",
    asset:"",
    dual:""
  });


  const {appindividualassets} = useGetAppIndividualAssetsQuery("appindasset", {
    selectFromResult: ({ data }) => ({
      appindividualassets: data?.entities
    }),
  })

  const {assetmaster} = useGetAssetMastersQuery("appindasset", {
    selectFromResult: ({ data }) => ({
      assetmaster: data?.entities
    }),
  })
  const [addAppIndvAsset] = useAddNewAppIndividualAssetMutation();
  const [updateAppIndvAsset] =  useUpdateAppIndividualAssetMutation();
  const [deleteAppIndvAsset] = useDeleteAppIndividualAssetMutation();

// Avoid a layout jump when reaching the last page with empty rows.
const emptyRows = 
page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
};

const onSubmit = async (event) =>{
  event.preventDefault();
  try{
    let bodyobject ={...newValue};
    const foundAsset = Object.values(appindividualassets).some(el => el.asset === newValue.asset);
    if(foundAsset){
      alert(`Asset already exists in the List`);
      let tempValue = {...newValue}
      tempValue.asset = "";
      tempValue.category = "";
      setNewValue(tempValue);
      return
    }
    if(!newValue?.category?.length){
      alert(`Please select value for Category`)
      return;
    }
    if(!newValue?.asset?.length){
      alert("Please select value for Asset");
      return
    }
    const res = await addAppIndvAsset(bodyobject) ;
    alert(`Asset ${newValue.asset} under ${newValue.category} added`);
    let tempValue = {...newValue}
    tempValue.asset = "";
    tempValue.category = "";
    setNewValue(tempValue);
  } catch(err){console.log(err)}
}

const onChangeAddValue= (event, newvalue, name) =>{
  let tempValue = {...newValue}
  tempValue = {...tempValue, [name]:newvalue}
  if(name === "category" && !newvalue?.length){
    tempValue.asset = "";
    tempValue.dual = "";
  }
  setNewValue(tempValue);
}

const handleEditFormSubmit = async (e) =>{
  e.preventDefault();
  if(!editFormData.asset.length || !editFormData.category.length || !editFormData?.dual?.length){
    return alert("Please Select all values before submitting");
  }
  try{
    setEditCategory(null);
    const response = await updateAppIndvAsset(editFormData);

  }catch(err){}
}

const handleCancelClick = (e) => {
  let tempEditFormData = {...editFormData};
  tempEditFormData.id = "";
  tempEditFormData.asset = "";
  tempEditFormData.category = "";
  tempEditFormData.dual = "";
  setEditFormData(tempEditFormData);
  setEditCategory(null);
}
const onChangeEditAppIndAsst = (event, newValue, name ,id) => {
  let tempEditFormData = {...editFormData};
  tempEditFormData = {...tempEditFormData, [name]:newValue}
  if(name === "category"){
    tempEditFormData.asset = "";
    tempEditFormData.dual = "";
  }
  setEditFormData(tempEditFormData);
}

const onClickEdit = (e,k,id) =>{
  let tempEditFormData = {...editFormData}
  tempEditFormData.id = id;
  tempEditFormData.category = appindividualassets[id].category;
  tempEditFormData.asset = appindividualassets[id].asset;
  tempEditFormData.dual = appindividualassets[id].dual;
  setEditCategory(k+1);
  setEditFormData(tempEditFormData);
}

const handleDeleteClick = async (e,k, id) => {
  e.preventDefault();
  let body = {"id":id}
  const result = await deleteAppIndvAsset(body);
}

useEffect(()=>{
  if(appindividualassets){
    const appindividualassetsArray = Object.values(appindividualassets);
    setTabledata(appindividualassetsArray);
  }
},[appindividualassets])

  return (
    <>
    <HeadingWrap>
        <Span>Applicable Individual Assets</Span>
    </HeadingWrap>
    <ComplaintCategoryWrapper>
      <Addcategform onSubmit={onSubmit}>        
        <Autocomplete
          isOptionEqualToValue={(option, value) => option.id === value.id}
          disablePortal
          id="combo-box-demo"
          size='small'
          value={newValue?.category || "" }
          onChange={(event, newValue) => onChangeAddValue(event, newValue, "category")}
          options={assetmaster? Object.values(assetmaster)?.map(x => x?.Category): []}
          sx={{backgroundColor:"white", width:"200px", marginLeft:"20px", marginRight:"20px",height:"40px"}}
          renderInput={(params) => <TextField {...params} label={"Select Category"} />}
        />
        <Autocomplete
          isOptionEqualToValue={(option, value) => option.id === value.id}
          disablePortal
          id="combo-box-demo"
          size='small'
          value={newValue?.asset || "" }
          onChange={(event, newValue) => onChangeAddValue(event, newValue, "asset")}
          options={(assetmaster && newValue?.category?.length)? Object.values(assetmaster)?.find(x => x.Category === newValue.category)?.Asset?.map(y => y.Name):[]}
          sx={{backgroundColor:"white", width:"200px", marginLeft:"20px", marginRight:"20px",height:"40px"}}
          renderInput={(params) => <TextField {...params} label={"Add Asset"} />}
        />
        <Autocomplete
          isOptionEqualToValue={(option, value) => option.id === value.id}
          disablePortal
          id="combo-box-demo"
          size='small'
          value={newValue?.dual || "" }
          onChange={(event, newValue) => onChangeAddValue(event, newValue, "dual")}
          options={(assetmaster && newValue?.category?.length && newValue?.asset?.length)? ["true", "false"]:[]}
          sx={{backgroundColor:"white", width:"200px", marginLeft:"20px", marginRight:"20px",height:"40px"}}
          renderInput={(params) => <TextField {...params} label={"Dual Applicable"} />}
        />
         
        <SubmitButton type='submit'>Submit</SubmitButton>
      </Addcategform>

      {/* <Button2Div>
          <ExcelDownload data={downloadData} filename={"officeTypes"} sheetName={"sheet1"}/>
      </Button2Div>  */}
    </ComplaintCategoryWrapper>

    <form onSubmit={handleEditFormSubmit}>

    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}  >
      <Table  aria-label="custom pagination table">
      <TableHead sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
        <TableRow>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"5%"}}} align="left">Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}} align="left">Asset</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}}  align="left">Category</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}}  align="left">Dual Applicable</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}}align="left">Edit</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
            <Fragment key={key*2}>
              {editCategory=== key+1 ?
                <AppIndAsstEditable row={row} k={key} editFormData={editFormData} 
                handleCancelClick={handleCancelClick} page={page} rowsPerPage={rowsPerPage} editCategory={editCategory} onChangeEditAppIndAsst={onChangeEditAppIndAsst} newValue={newValue} tableFontSize={tableFontSize} SubmitButton={SubmitButton} assetmaster = {assetmaster}
               />

                :<AppIndAsstReadOnly row={row} k={key} tabledata={tabledata} onClickEdit={onClickEdit}
                  handleDeleteClick= {handleDeleteClick} page={page} rowsPerPage={rowsPerPage} editCategory={editCategory} ChipDiv={ChipDiv} tableFontSize={tableFontSize} SubmitButton={SubmitButton}            
                />
                 }
            </Fragment>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>    
     </>
  )
}
export default AppIndividualAssets
